import { render, staticRenderFns } from "./reporteHuellaCarbono.vue?vue&type=template&id=3952f6bc&scoped=true&"
import script from "./reporteHuellaCarbono.vue?vue&type=script&lang=ts&"
export * from "./reporteHuellaCarbono.vue?vue&type=script&lang=ts&"
import style0 from "./reporteHuellaCarbono.vue?vue&type=style&index=0&id=3952f6bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3952f6bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3952f6bc', component.options)
    } else {
      api.reload('3952f6bc', component.options)
    }
    module.hot.accept("./reporteHuellaCarbono.vue?vue&type=template&id=3952f6bc&scoped=true&", function () {
      api.rerender('3952f6bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MedioAmbiente/Reporte/reporteHuellaCarbono.vue"
export default component.exports